import ProductCard from './ProductCard'

function SkeletonCard() {
  return (
    <div className="card animate-pulse">
      <div className="aspect-square skeleton rounded-none" />
      <div className="p-4 space-y-2">
        <div className="h-3 skeleton rounded w-16" />
        <div className="h-4 skeleton rounded w-3/4" />
        <div className="h-4 skeleton rounded w-1/2" />
        <div className="h-5 skeleton rounded w-1/3 mt-3" />
      </div>
    </div>
  )
}

export default function ProductGrid({ products, loading, view = 'grid', emptyMessage = 'No products found.' }) {
  if (loading) {
    return (
      <div className={view === 'grid'
        ? 'grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4'
        : 'flex flex-col gap-3'
      }>
        {[...Array(8)].map((_, i) => (
          view === 'grid' ? <SkeletonCard key={i} /> :
          <div key={i} className="card h-28 animate-pulse flex gap-4 p-4">
            <div className="w-24 h-full skeleton rounded-lg" />
            <div className="flex-1 space-y-2">
              <div className="h-4 skeleton rounded w-3/4" />
              <div className="h-3 skeleton rounded w-1/2" />
              <div className="h-5 skeleton rounded w-1/3" />
            </div>
          </div>
        ))}
      </div>
    )
  }

  if (!products?.length) {
    return (
      <div className="text-center py-16 text-gray-400">
        <div className="text-6xl mb-4">🔍</div>
        <p className="text-lg font-display">{emptyMessage}</p>
      </div>
    )
  }

  return (
    <div className={view === 'grid'
      ? 'grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4'
      : 'flex flex-col gap-3'
    }>
      {products.map(product => (
        <ProductCard key={product.id} product={product} view={view} />
      ))}
    </div>
  )
}
